export const brandConfigObjectMap = new Map();

export const Brands = {
    TelkomSouthAfricaEnglish: 'tlk-za-en',
};
brandConfigObjectMap.set(Brands.TelkomSouthAfricaEnglish, {
    gameTitle: 'Melody Madness',
    freePlayServiceId: 'telkom-melody-madness-free',
    baseRoute: '/login',
    newIntegration: false,
    isMelodyMadness: true,
});
